import { Component, OnDestroy, OnInit } from '@angular/core'
import { LiveVideoComponent } from './live-video/live-video.component'
import { BetSectionComponent } from './bet-section/bet-section.component'
import { CardsDealComponent } from './cards-deal/cards-deal.component'
import { WinStreakComponent } from './win-streak/win-streak.component'
import { CurrentBetsComponent } from './current-bets/current-bets.component'
import { WebSocketService } from '@core/services'
import { BetService, RushGameService } from '@rush-shared/services'
import { RushModeEnum } from '@core/enums'
import { TimerV3Component } from '@shared/components'
import { CommonModule } from '@angular/common'
import { RushGameHttp } from '@rush-core/https'
import { TrendComponent } from './trend/trend.component'
import {
  BetConfirmationAlertComponent,
  LiveMessagesComponent,
  PleaseStandByComponent,
} from '@rush-shared/components'
import { LiveMessageTypeEnum } from '@rush-shared/enums'
import { LiveMessageModel } from '@rush-shared/models'
import { filter } from 'rxjs'

@Component({
  selector: 'app-rush',
  standalone: true,
  imports: [
    LiveVideoComponent,
    LiveMessagesComponent,
    BetSectionComponent,
    CardsDealComponent,
    WinStreakComponent,
    CurrentBetsComponent,
    TimerV3Component,
    CommonModule,
    TrendComponent,
    PleaseStandByComponent,
    BetConfirmationAlertComponent,
  ],
  templateUrl: './rush.component.html',
  styleUrl: './rush.component.sass',
})
export class RushComponent implements OnInit, OnDestroy {
  get currentBet() {
    return this._betService.currentBet$.value
  }
  get betValue() {
    return this._betService.betValue || 0
  }

  constructor(
    private _webSocketService: WebSocketService,
    private _rushGameService: RushGameService,
    private _rushGameHttp: RushGameHttp,
    public _betService: BetService,
  ) {}

  countdown: number

  liveMessageTypeEnum = LiveMessageTypeEnum
  rushLiveMessages: LiveMessageModel[] = []

  betConfirmed = false

  get standby(): boolean {
    return this._rushGameService.mode$.value === RushModeEnum.Paused
  }

  ngOnInit(): void {
    this._webSocketService.listenToRushMode(({ mode }) => {
      this._rushGameService.setMode(mode)

      if (mode === RushModeEnum.Setup) {
        this._rushGameService.setCardsDeal({})
        setTimeout(() => {
          this._rushGameHttp.getRushCurrentConfig().subscribe((i) => {
            this._rushGameService.setDealNo(i.dealNo)
          })
        }, 2000)
      }

      if (mode === RushModeEnum.DealOpen) {
        this._rushGameHttp.getRushCurrentConfig().subscribe((i) => {
          this._rushGameService.setDealNo(i.dealNo)
        })
      }
    })

    this._webSocketService.listenToRushCountdown((timeRemaining: number) => {
      this.countdown = timeRemaining
    })

    this._webSocketService.listenToRushGameHistory((gameHistory) => {
      this._rushGameService.setGameHistories(gameHistory)
    })

    this._webSocketService.listenToRushCardsConfirmation(({ isConfirm, cards }) => {
      if (isConfirm) {
        const [firstCard, secondCard, maverickCard] = cards
        this._rushGameService.setCardsDeal({
          first: firstCard,
          second: secondCard,
          maverick: maverickCard,
        })
      }
    })

    this._betService.currentBet$.observer.pipe(filter((i) => i.chips > 0)).subscribe((i) => {
      this.betConfirmed = true
    })

    this.getInitData()
  }

  ngOnDestroy(): void {
    this._webSocketService.closeAllListeners()
  }

  getInitData(): void {
    this._rushGameHttp.getRushInitData().subscribe((i) => {
      this.rushLiveMessages = i.rushLiveMessages
      this._rushGameService.setMode(i.gameConfig.mode)
      this._rushGameService.setDealNo(i.gameConfig.dealNo)
      this._rushGameService.setGameHistories(i.gameHistory)
    })
  }
}
